type Props =
  | { imageUrl: string; image?: never; alt?: string }
  | { imageUrl?: never; image: React.ReactNode; alt?: never };

export const ImageOrNode = ({ imageUrl, image, alt }: Props) => {
  if (imageUrl) {
    return <img src={imageUrl} style={{ width: "100%" }} alt={alt ?? ""} />;
  }

  return <>{image}</>;
};
